import * as tus from 'tus-js-client';
import { extendObservable, action } from 'mobx';
import FormService from './FormService';
import { Subject } from 'rxjs';

class VideoUploadService {
  form = new FormService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
  }

  init = action(() => {
    this.form.reset();
    this.form.setInitialValues({});
  });

  handleUpload = action((file, uploadUrl) => {
    const url = new URL(uploadUrl);
    const signature = url.searchParams.get('AuthorizationSignature');
    const expiration = url.searchParams.get('AuthorizationExpire');
    const vid = url.searchParams.get('VideoId');
    const libId = url.searchParams.get('LibraryId');

    this.isOpen = true;
    const subject = new Subject();
    this.uploader = new tus.Upload(file, {
      endpoint: url.href.replace(url.search, ''),
      retryDelays: [0, 3000, 5000],
      uploadSize: file.size,
      headers: {
        AuthorizationSignature: signature,
        AuthorizationExpire: expiration,
        VideoId: vid,
        LibraryId: libId,
      },
      removeFingerprintOnSuccess: true,
      metadata: {
        filename: file.name,
        filetype: file.type,
      },
      onProgress: (bytesUploaded, bytesTotal) => {
        const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
        this.handleUploadProgress(percentage);
        subject.next(percentage);
      },
      onError: function (error) {
        subject.error(error);
      },
      onSuccess: function () {
        subject.complete();
      },
    });
    this.uploader.start();
    this.subject = subject;
    return this.subject;
  });

  handleUploadProgress = action((percentage) => {
    this.form.setValue('uploadPercentage', percentage);
    if (percentage >= 100) {
      this.isOpen = false;
    }
  });
}

const contentVideoUploadService = new VideoUploadService();

export default contentVideoUploadService;

export { VideoUploadService };
